import BackboneEvents from 'backbone-events-standalone';

function enrichEmitter(emitter) {
    Object.assign(emitter, {
        _eventsWaitingForAListener: {},

        /**
         * Same as BackboneEvents.trigger(...) except that it will wait for at least one listener to be registered for the
         * specified event before triggering it.
         *
         * @param {String} eventName the name of the event to trigger
         * @param {Object} args (optional) arguments to be passed to listeners
         * @return {BackboneEvents} this emitter
         */
        triggerOnceThereIsAtLeastOneListener(eventName, ...args) {
            const listeners = this._events && this._events[eventName];
            if (listeners && listeners.length) {
                this.trigger(eventName, ...args);
            } else {
                if (!this._eventsWaitingForAListener[eventName]) {
                    this._eventsWaitingForAListener[eventName] = [];
                }
                this._eventsWaitingForAListener[eventName].push({args});
            }
            return this;
        },
    });

    ['on', 'once', 'bind'].forEach((listenerRegistrationMethodName) => {
        const originalDefinition = emitter[listenerRegistrationMethodName].bind(emitter);

        emitter[listenerRegistrationMethodName] = function (eventName, ...registrationArgs) {
            originalDefinition(eventName, ...registrationArgs);

            const eventsWaitingForAListener = this._eventsWaitingForAListener[eventName];
            if (eventsWaitingForAListener) {
                eventsWaitingForAListener.forEach((evt) => {
                    this.trigger(eventName, ...evt.args);
                });
            }
            delete this._eventsWaitingForAListener[eventName];
        };
    });

    ['listenTo', 'listenToOnce'].forEach((listenerRegistrationMethodName) => {
        const originalDefinition = emitter[listenerRegistrationMethodName].bind(emitter);

        emitter[listenerRegistrationMethodName] = function (target, eventName, ...registrationArgs) {
            originalDefinition(target, eventName, ...registrationArgs);

            const eventsWaitingForAListener = target._eventsWaitingForAListener[eventName];
            if (eventsWaitingForAListener) {
                eventsWaitingForAListener.forEach((evt) => {
                    target.trigger(eventName, ...evt.args);
                });
            }
            delete target._eventsWaitingForAListener[eventName];
        };
    });
}

export function mixin(Hop) {
    Hop.eventEmitter = (target = {}, listeners = {}) => {
        const emitter = BackboneEvents.mixin(target);
        enrichEmitter(emitter);
        Hop.keys(listeners).forEach((event) => emitter.on(event, listeners[event]));
        return emitter;
    };

    // Currently, Micro-Frontends need Hop.events to communicate with hosting apps
    // Randomly, MF scripts can be added before Hop.events object is ready
    // So, we need to make sure it is well defined before adding MF scripts
    // See: src/main/resources/META-INF/resources/WEB-INF/jsp/common/micro-frontend/starter.jsp
    const event = new CustomEvent('hop:eventsReady');
    window.dispatchEvent(event);
}
